import { inject, Injectable } from '@angular/core';
import { Query } from '@datorama/akita';

import { ClosingPageState, ClosingPageStore } from './closing-page.store';

@Injectable({ providedIn: 'root' })
export class ClosingPageQuery extends Query<ClosingPageState> {
  protected store: ClosingPageStore;

  constructor() {
    const store = inject(ClosingPageStore);

    super(store);

    this.store = store;
  }
}
